import { useState } from 'react';

import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  SwipeableDrawer,
  Toolbar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { BrandWordmark } from 'components/common';
import { navRailBreakpoint } from '@theme/variables';
import { DrawerContent } from './components/DrawerContent';

const drawerWidth = '256px';
const navId = 'app-navigation';
const MENU_BUTTON_SIZE = 44;

export const NavDrawer: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };
  const handleDrawerOpen = () => {
    setMobileOpen(true);
  };
  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <>
      <AppBar
        sx={(theme) => ({
          display: { xs: 'block', [navRailBreakpoint]: 'none' },
          background: '#FFF',
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Toolbar sx={{ px: 3 }}>
          <Box display="flex" gap={1.25}>
            <IconButton
              aria-label={mobileOpen ? 'Close navigation' : 'Open navigation'}
              aria-expanded={mobileOpen}
              aria-controls={navId}
              onClick={handleDrawerToggle}
              sx={{
                width: MENU_BUTTON_SIZE,
                height: MENU_BUTTON_SIZE,
                borderRadius: 2,
                color: 'common.white',
                backgroundColor: 'brand.accent',
                '&:hover': { backgroundColor: 'brand.accent' },
                display: { [navRailBreakpoint]: 'none' },
              }}
            >
              <MenuIcon />
            </IconButton>
            <BrandWordmark height={MENU_BUTTON_SIZE} />
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar
        sx={{ flexShrink: 0, display: { [navRailBreakpoint]: 'none' } }}
      />
      <Box
        component="nav"
        id={navId}
        sx={{
          width: { [navRailBreakpoint]: drawerWidth },
          flexShrink: { sm: 0 },
        }}
      >
        <SwipeableDrawer
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          onOpen={handleDrawerOpen}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', [navRailBreakpoint]: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              height: '100dvh',
            },
          }}
        >
          <DrawerContent onNavigate={handleDrawerClose} />
        </SwipeableDrawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', [navRailBreakpoint]: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              height: '100dvh',
            },
          }}
          open
        >
          <DrawerContent />
        </Drawer>
      </Box>
    </>
  );
};
